<div *ngFor="let productTimeSpan of productTimeSpans" class="col-12 col-md">
  <div [class.selected]="isProductTimeSpanSelected(productTimeSpan)" class="ticket-duration pb-3" [ngClass]="{ elinactive: !productTimeSpan.isCapacityAvailable }">
    <div class="basket-info">
      <app-product-time-span [productTimeSpan]="productTimeSpan" (click)="onClick(productTimeSpan)"></app-product-time-span>
    </div>
  </div>
</div>
